<template>
    <rkm-area
        background-color="secondary"
        closed
        header-prefix-icon="history"
        no-margin-top
        title="Antecedentes"
        type="box"
    >
        <rkm-tabs>
            <rkm-tab title="Paciente">
                <BoxPaciente :data="data" />
            </rkm-tab>

            <rkm-tab title="Familiar">
                <BoxFamiliar :data="data" />
            </rkm-tab>
        </rkm-tabs>
    </rkm-area>
</template>

<script>
import BoxFamiliar from './components/familiar/Form'
import BoxPaciente from './components/paciente/Form'

export default {
    components: {
        BoxFamiliar,
        BoxPaciente,
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>